import {Component, EventEmitter, forwardRef, Input, Output} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';

@Component({
    selector: 'app-date-time-picker',
    templateUrl: './date-time-picker.component.html',
    styleUrls: ['./date-time-picker.component.scss'],
    providers: [
        {provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => DateTimePickerComponent), multi: true}
    ]
})
export class DateTimePickerComponent implements ControlValueAccessor {
    @Input() label: string;
    @Input() name: string;
    @Input() required: boolean;
    @Input() initialDate: Date;
    @Output() dateChange: EventEmitter<any> = new EventEmitter();
    usedInitial: boolean = false;


    _dateTime: Date | string;

    propagateChange: any = () => {};

    // @ts-ignore
    get dateTime(): Date | string {
        if (!this.usedInitial && this.initialDate != undefined) {
            this._dateTime = new Date(this.initialDate);
            this.usedInitial = true;
        }
        return this._dateTime;
    }

    // @ts-ignore
    set dateTime(input: Date | string) {
        this._dateTime = input;
        if (input instanceof Date) {
            this.propagateChange((input as Date).toISOString());
        } else {
            this.propagateChange(input || '');
        }
        this.dateChange.emit(input);
    }

    registerOnChange(fn) {
        this.propagateChange = fn;
    }

    registerOnTouched(fn: any): void {
    }

    writeValue(input: string) {
        if (input !== null) {
            this._dateTime = input;
        }
    }

}
